/**
 * Care dintre cele doua ecrane de login se randeaza — functie PURA, ca sa fie testabila fara
 * provideri montati si fara sa depinda de valorile inline-uite la build.
 *
 * Cele doua flaguri sunt INDEPENDENTE (`VITE_AUTH_PAROLA` si `VITE_AUTENTIFICARE_COD`), deci
 * combinatia „amandoua oprite" e posibila. Ea se **scrie**, nu se presupune: fara autentificare
 * cu cod nu exista nicio alta cale de intrare in platforma, asa ca varianta cu parola ramane —
 * oricat ar spune flagul de parola. Un ecran de login fara nicio cale de intrare ar fi mai rau
 * decat un ecran de login pe care scrie «parola».
 *
 * Tiparul e cel din `LoginPage`, unde cele doua blocuri de «cod» isi scriu deja explicit cazul in
 * care celalalt lipseste (separatorul «sau» dublat).
 */
export type VariantaLogin = 'cod' | 'parola';

export function variantaLogin(
  parolaActiva: boolean,
  autentificareCodActiva: boolean
): VariantaLogin {
  if (!autentificareCodActiva) return 'parola';
  return parolaActiva ? 'parola' : 'cod';
}
